/* eslint-disable prefer-destructuring */
/* eslint-disable array-callback-return */
/* eslint-disable no-param-reassign */
import { createSlice } from "@reduxjs/toolkit";
import {
  addBatteryAmbulance,
  createTrip,
  deleteFarmerActivity,
  deleteTrip,
  editBatteryAmbulance,
  editTrip,
  endTripByAdmin,
  getCurrentTripStatus,
  getDistance,
  getFarmerSummary,
  getKpiData,
  getOverallSummary,
  getStopSummary,
  getTrikesAndDriversForTrip,
  getTripById,
  getTripDetailsKPI,
  getTrips,
  getTripsForDriverV3,
  getTripsForTrikeId,
  getTripsForTrikeV3,
  getTripsV3,
  optimiseRoute,
} from "../APIs/tripsAPI";
import {
  getTrikeBreakdownByTrip,
  rejectTrikeBreakdown,
  requestTrikeReplacement,
} from "../APIs/trikeBreakdownAPI";
import {
  getBatterySosByTrip,
  assignBatterySosAgent,
  rejectBatterySos,
  getHubWiseBatteries,
} from "../APIs/batterySosAPI";

const initialState = {
  loading: false,
  error: null,
  activeBatterySosRequest: null,
  hubWiseBatteries: [],
  allTrips: [
    {
      tripId: "--",
      driverName: "--",
      trikeId: "--",
      stops: [],
      startDate: null,
      endDate: null,
      occurence: false,
      daysOfOccurence: [],
      timeSlot: null,
      endTime: null,
      distance: null,
      time: null,
    },
  ],
  currentTrip: [],
  tripsForTrikeId: [
    {
      tripId: "--",
      driverName: "--",
      trikeId: "--",
      stops: [],
      startDate: null,
      endDate: null,
      occurence: false,
      daysOfOccurence: [],
      timeSlot: null,
      distance: null,
      time: null,
    },
  ],
  initialStop: {
    id: 1,
    location: "Stop",
    locationId: 1,
    activities: [],
  },

  stops: [
    {
      id: 1,
      location: "Stop",
      locationId: "1",
      activities: [],
      locationType: 1,
    },
    {
      id: 2,
      location: "Stop",
      locationId: "1",
      activities: [],
      locationType: 1,
    },
  ],
  currentRoute: [],
  optimisedRouteDistance: null,
  optimisedRouteTime: null,
  calculatedRouteDistance: null,
  calculatedRouteTime: null,
  calculateRouteAndDistanceVisible: false,
  currentStep: 1,
  tripDetails: {
    id: null,
    startDate: null,
    endDate: null,
    timeSlot: null,
    occurence: false,
    daysOfOccurence: [],
    driverId: "",
    driverName: "",
    trikeId: "",
    trikeRegistrationNo: "",
    statusId: 0,
    distance: null,
    time: null,
    batteries: [],
    trikeType: "",
    containerType: 0,
    canisters: 0,
    crates: 0,
  },
  filtersForTrips: {
    drivers: [],
    trikeId: [],
    status: [],
  },
  validationForSteps: {
    step1: {
      stopLength: false,
      location: false,
      activity: [],
    },
    step2: {
      startDate: false,
      timeSlot: false,
      daysOfOccurence: false,
      endDate: false,
      canisters: false,
      crates: false,
    },
    step3: false,
  },

  trikesForTrips: [],
  driversForTrips: [],
  deleteTripModal: {
    visible: false,
    id: null,
  },
  tripStep1Modal: false,
  cancelTripModal: false,
  optimisingRouteModal: false,
  isRouteOptimised: false,
  optimisationNotPossibleModal: false,
  missingActivityModal: {
    visible: false,
    missingActivities: [],
  },
  toastMessage: {
    visible: false,
    type: "",
    id: 2,
  },
  fullScreenMapForTrips: {
    visible: false,
    polygonCoordinates: [],
    pointColor: 2,
  },
  editTripDetails: {
    tripId: null,
    flag: false,
  },
  tripIdForListings: "",
  snapToRoadCoordinates: [],
  fastestRouteCoordinates: [],

  // phase 3
  kpiData: {
    upcomingTrips: 0,
    ongoingTrips: 0,
    completedTrips: 0,
    total: 0,
  },
  tripsListV3: {
    result: [],
    totalRecords: 0,
  },
  tripDetailsKPI: {
    stops: 0,
    distance: 0,
    totalCollected: 0,
    totalDelivered: 0,
    spoiltMilkForStops: 0,
    excessSpoiltMilk: 0,
    startTime: "",
    endTime: "",
    spoiltByDriver: 0,
  },
  currentPage: 1,
  tripsForTrike: {
    result: [],
    totalRecords: 0,
  },
  tripsForDriver: [],
  currentStop: {
    id: 0,
    name: "",
    index: 0,
  },
  currentFarmer: {
    id: "",
    name: "",
    index: 0,
  },
  overallSummaryForTrip: {},
  stopSummaryForTrip: [],
  farmerSummaryForTrip: [],
  endTripByAdminModal: {
    visible: false,
    tripId: 0,
  },
  dropdownActive: false,
  editBatterySOS: false,
  farmerSummary: [],
  stopSummary: [],
  editCommodityModal: {
    visible: false,
    data: [],
  },
  spoiltMilkModal: {
    visible: false,
    stops: 0,
    excess: 0,
  },
  driverRatingModal: {
    visible: false,
    tripId: 0,
    driverId: 0,
  },
  editProduceModal: {
    visible: false,
    data: {},
  },
  receiptModal: {
    visible: false,
    data: {},
  },
  deleteFarmerActivityModal: {
    visible: false,
    data: {},
  },
  batterySwapRequestModal: {
    visible: false,
    data: {},
  },
  trikeRepairModal: {
    visible: false,
    data: {},
  },
  reviewLocationModal: {
    visible: false,
    data: {},
  },
  activeBreakdownRequest: null,
};

export const tripsSlice = createSlice({
  name: "trips",
  initialState,
  reducers: {
    updateTrips: (state, action) => {
      state[action.payload.key] = action.payload.value;
    },
    updateMultipleTrips: (state, action) => {
      action.payload.map((item) => {
        state[item.key] = item.value;
      });
    },
    updateItemById: (state, action) => {
      const { arrayKey, itemId, updatedData } = action.payload;

      const updatedArray = state[arrayKey].map((item) => {
        if (item.id === itemId) {
          return { ...item, ...updatedData };
        }
        return item;
      });

      state[arrayKey] = updatedArray;
    },
    deleteActivityForStop: (state, action) => {
      const { itemId, activityId } = action.payload;

      const updatedArray = state.stops.map((item) => {
        if (item.id === itemId) {
          const updatedActivities = item.activities.filter(
            (activity) => activity.id !== activityId,
          );

          return { ...item, activities: updatedActivities };
        }
        return item;
      });

      state.stops = updatedArray;
    },
    updateActivityForStop: (state, action) => {
      const { newActivity, itemId } = action.payload;

      const updatedArray = state.stops.map((item) => {
        if (item.id === itemId) {
          return { ...item, activities: [...item.activities, newActivity] };
        }
        return item;
      });

      state.stops = updatedArray;
    },
    resetTrips: (state, action) => {
      action.payload.map((item) => {
        state[item] = initialState[item];
      });
    },
    deleteStop: (state, action) => {
      const { stopId } = action.payload;
      if (state.stops.length === 1) {
        state.stops = [state.initialStop];
      } else {
        const updatedArray = state.stops.filter((item) => item.id !== stopId);
        updatedArray.forEach((item, index) => {
          item.id = index + 1;
        });

        state.stops = updatedArray;
      }
    },
    updateStopDataForOverallSummary: (state, action) => {
      state.overallSummaryForTrip.stops = action.payload.value;
    },
  },
  extraReducers(builder) {
    // create trip
    builder.addCase(createTrip.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(createTrip.fulfilled, (state) => {
      state.loading = false;
      state.status = "fulfilled";
    });
    builder.addCase(createTrip.rejected, (state, { payload }) => {
      state.loading = false;
      state.status = "rejected";
      state.error = payload;
    });

    // get trip details
    builder.addCase(getTrips.pending, (state) => {
      state.loading = true;
    });

    builder.addCase(getTrips.fulfilled, (state, action) => {
      state.loading = false;
      state.status = "fulfilled";

      const responseData = action.payload.map((item) => ({
        tripId: item.id.toString(),
        driverName: item.driver_name,
        trikeId: item.trike_id,
        stops: item.stops,
        startDate: item.start_date,
        endDate: item.end_date,
        occurence: item.occurence,
        daysOfOccurence: item.occurence_days,
        timeSlot: item.time_slot,
        statusId: item.status_id,
        startTime: item?.start_time,
        endTime: item?.end_time,
        distance: item?.distance,
        time: item?.time,
      }));

      state.allTrips = responseData;
    });
    builder.addCase(getTrips.rejected, (state, action) => {
      state.loading = false;
      state.status = "rejected";
      state.error = action.error;
    });

    // delete trip
    builder.addCase(deleteTrip.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(deleteTrip.fulfilled, (state) => {
      state.loading = false;
      state.status = "fulfilled";
    });
    builder.addCase(deleteTrip.rejected, (state, { payload }) => {
      state.loading = false;
      state.status = "rejected";
      state.error = payload;
    });

    // edit trip
    builder.addCase(editTrip.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(editTrip.fulfilled, (state) => {
      state.loading = false;
      state.status = "fulfilled";
    });
    builder.addCase(editTrip.rejected, (state, { payload }) => {
      state.loading = false;
      state.status = "rejected";
      state.error = payload;
    });

    // trips for trike id
    builder.addCase(getTripsForTrikeId.pending, (state) => {
      state.loading = true;
    });

    builder.addCase(getTripsForTrikeId.fulfilled, (state, action) => {
      state.loading = false;
      state.status = "fulfilled";

      if (action.payload && action.payload.length > 0) {
        const responseData = action?.payload.map((item) => ({
          tripId: item.id.toString(),
          driverName: item.driver_name,
          trikeId: item.trike_id,
          stops: item.stops,
          startDate: item.start_date,
          endDate: item.end_date,
          occurence: item.occurence,
          daysOfOccurence: item.occurence_days,
          timeSlot: item.time_slot,
          statusId: item.status_id,
          distance: item?.distance,
          time: item?.time,
          startTime: item?.start_time,
          endTime: item?.end_time,
        }));

        state.tripsForTrikeId = responseData;
      } else {
        state.tripsForTrikeId = [];
      }
    });
    builder.addCase(getTripsForTrikeId.rejected, (state, action) => {
      state.loading = false;
      state.status = "rejected";
      state.error = action.error;
    });

    // optimise route
    builder.addCase(optimiseRoute.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(optimiseRoute.fulfilled, (state, action) => {
      state.loading = false;
      state.status = "fulfilled";

      const {
        currentRoute,
        optimisedRoute,
        optimisedRouteDistance,
        totalRoutes,
      } = action.payload;

      if (totalRoutes > 0) {
        state.stops = optimisedRoute;
        state.currentRoute = currentRoute;
      }

      state.optimisedRouteDistance = optimisedRouteDistance;
      state.optimisationNotPossibleModal = totalRoutes === 0;
    });
    builder.addCase(optimiseRoute.rejected, (state, { payload }) => {
      state.loading = false;
      state.status = "rejected";
      state.error = payload;
    });

    // get trikes and drivers for trips

    builder.addCase(getTrikesAndDriversForTrip.pending, (state) => {
      state.loading = true;
    });

    builder.addCase(getTrikesAndDriversForTrip.fulfilled, (state, action) => {
      state.loading = false;
      state.status = "fulfilled";

      const responseForTrikes = action.payload?.trikes?.map((trike, index) => ({
        id: index + 1,
        value: trike.trike_id,
      }));

      const responseForDrivers = action.payload?.drivers?.map(
        (driver, index) => ({
          id: index + 1,
          value: driver.driver_name,
        }),
      );

      state.trikesForTrips = responseForTrikes;
      state.driversForTrips = responseForDrivers;
    });
    builder.addCase(getTrikesAndDriversForTrip.rejected, (state, action) => {
      state.loading = false;
      state.status = "rejected";
      state.error = action.error;
    });

    // get distance for stops
    builder.addCase(getDistance.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getDistance.fulfilled, (state, action) => {
      state.loading = false;
      state.status = "fulfilled";

      const { distance, time } = action.payload;

      state.calculatedRouteDistance = distance;
      state.calculatedRouteTime = time;
    });
    builder.addCase(getDistance.rejected, (state, { payload }) => {
      state.loading = false;
      state.status = "rejected";
      state.error = payload;
    });

    // phase 3

    // get trips
    builder.addCase(getTripsV3.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getTripsV3.fulfilled, (state, action) => {
      state.loading = false;
      state.status = "fulfilled";
      state.tripsListV3 = action.payload;
    });
    builder.addCase(getTripsV3.rejected, (state, { payload }) => {
      state.loading = false;
      state.status = "rejected";
      state.error = payload;
    });

    // get trip by id
    builder.addCase(getTripById.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getTripById.fulfilled, (state, action) => {
      state.loading = false;
      state.status = "fulfilled";
      state.tripDetails = { ...state.tripDetails, ...action.payload.result };
      state.stops = action.payload.stops;
    });
    builder.addCase(getTripById.rejected, (state, action) => {
      state.loading = false;
      state.status = "rejected";
      state.error = action.error;
    });

    // get kpi data
    builder.addCase(getKpiData.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getKpiData.fulfilled, (state, action) => {
      state.loading = false;
      state.status = "fulfilled";
      state.kpiData = action.payload.kpi;
    });
    builder.addCase(getKpiData.rejected, (state, { payload }) => {
      state.loading = false;
      state.status = "rejected";
      state.error = payload;
    });

    // get trips for trike id
    builder.addCase(getTripsForTrikeV3.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getTripsForTrikeV3.fulfilled, (state, action) => {
      state.loading = false;
      state.status = "fulfilled";
      state.tripsForTrike = action.payload.response;
    });
    builder.addCase(getTripsForTrikeV3.rejected, (state, { payload }) => {
      state.loading = false;
      state.status = "rejected";
      state.error = payload;
    });

    // get trips for driver
    builder.addCase(getTripsForDriverV3.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getTripsForDriverV3.fulfilled, (state, action) => {
      state.loading = false;
      state.status = "fulfilled";
      state.tripsForDriver = action.payload.trips;
    });
    builder.addCase(getTripsForDriverV3.rejected, (state, { payload }) => {
      state.loading = false;
      state.status = "rejected";
      state.error = payload;
    });

    // get overall trip summary
    builder.addCase(getOverallSummary.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getOverallSummary.fulfilled, (state, action) => {
      state.loading = false;
      state.status = "fulfilled";
      state.overallSummaryForTrip = action.payload.tripSummary;
    });
    builder.addCase(getOverallSummary.rejected, (state, { payload }) => {
      state.loading = false;
      state.status = "rejected";
      state.error = payload;
    });

    // end trip by admin
    builder.addCase(endTripByAdmin.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(endTripByAdmin.fulfilled, (state) => {
      state.loading = false;
      state.status = "fulfilled";
    });
    builder.addCase(endTripByAdmin.rejected, (state, { payload }) => {
      state.loading = false;
      state.status = "rejected";
      state.error = payload;
    });

    // get trip details kpi
    builder.addCase(getTripDetailsKPI.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getTripDetailsKPI.fulfilled, (state, action) => {
      state.loading = false;
      state.status = "fulfilled";
      const { message, ...rest } = action.payload;
      state.tripDetailsKPI = rest;
    });
    builder.addCase(getTripDetailsKPI.rejected, (state, { payload }) => {
      state.loading = false;
      state.status = "rejected";
      state.error = payload;
    });

    // add battery ambulance
    builder.addCase(addBatteryAmbulance.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(addBatteryAmbulance.fulfilled, (state) => {
      state.loading = false;
      state.status = "fulfilled";
    });
    builder.addCase(addBatteryAmbulance.rejected, (state, { payload }) => {
      state.loading = false;
      state.status = "rejected";
      state.error = payload;
    });

    // edit battery ambulance
    builder.addCase(editBatteryAmbulance.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(editBatteryAmbulance.fulfilled, (state) => {
      state.loading = false;
      state.status = "fulfilled";
    });
    builder.addCase(editBatteryAmbulance.rejected, (state, { payload }) => {
      state.loading = false;
      state.status = "rejected";
      state.error = payload;
    });

    // get farmer summary
    builder.addCase(getFarmerSummary.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getFarmerSummary.fulfilled, (state, action) => {
      state.loading = false;
      state.status = "fulfilled";
      state.farmerSummary = action.payload.farmerSummary;
    });
    builder.addCase(getFarmerSummary.rejected, (state, { payload }) => {
      state.loading = false;
      state.status = "rejected";
      state.error = payload;
    });

    // get stop summary
    builder.addCase(getStopSummary.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getStopSummary.fulfilled, (state, action) => {
      state.loading = false;
      state.status = "fulfilled";
      state.stopSummary = action.payload.farmerActivity;
    });
    builder.addCase(getStopSummary.rejected, (state, { payload }) => {
      state.loading = false;
      state.status = "rejected";
      state.error = payload;
    });

    // get current trip status
    builder.addCase(getCurrentTripStatus.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getCurrentTripStatus.fulfilled, (state, action) => {
      state.loading = false;
      state.status = "fulfilled";

      const statusId = action?.payload?.result?.statusId ?? 0;
      const receiptStatus = action?.payload?.result?.receiptStatus ?? 0;

      const updateObj = {};

      if (statusId) updateObj.statusId = statusId;
      if (receiptStatus) updateObj.receiptStatus = receiptStatus;

      state.currentTrip = { ...state.currentTrip, ...updateObj };
    });
    builder.addCase(getCurrentTripStatus.rejected, (state, { payload }) => {
      state.loading = false;
      state.status = "rejected";
      state.error = payload;
    });

    // delete farmer activity
    builder.addCase(deleteFarmerActivity.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(deleteFarmerActivity.fulfilled, (state) => {
      state.loading = false;
      state.status = "fulfilled";
    });
    builder.addCase(deleteFarmerActivity.rejected, (state, { payload }) => {
      state.loading = false;
      state.status = "rejected";
      state.error = payload;
    });

    // get trike breakdown request details
    builder.addCase(getTrikeBreakdownByTrip.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getTrikeBreakdownByTrip.fulfilled, (state, action) => {
      state.loading = false;
      state.activeBreakdownRequest = action.payload;
    });
    builder.addCase(getTrikeBreakdownByTrip.rejected, (state, { payload }) => {
      state.loading = false;
      state.error = payload;
    });

    // reject trike breakdown request
    builder.addCase(rejectTrikeBreakdown.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(rejectTrikeBreakdown.fulfilled, (state, action) => {
      state.loading = false;
      if (state.activeBreakdownRequest) {
        state.activeBreakdownRequest.status = 3; // REJECTED
        if (action.payload) {
          state.activeBreakdownRequest.rejectionReason =
            action.payload.rejectionReason;
          state.activeBreakdownRequest.rejectedBy =
            action.payload.rejectedBy;
          state.activeBreakdownRequest.rejectedByName =
            action.payload.rejectedByName;
          state.activeBreakdownRequest.rejectedAt =
            action.payload.rejectedAt;
        }
      }
    });
    builder.addCase(rejectTrikeBreakdown.rejected, (state, { payload }) => {
      state.loading = false;
      state.error = payload;
    });

    // request trike replacement
    builder.addCase(requestTrikeReplacement.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(requestTrikeReplacement.fulfilled, (state, action) => {
      state.loading = false;
      if (state.activeBreakdownRequest) {
        state.activeBreakdownRequest.status = 6; // REPLACEMENT_REQUESTED
        if (action.payload) {
          state.activeBreakdownRequest.replacementReason =
            action.payload.replacementReason;
          state.activeBreakdownRequest.replacementRaisedBy =
            action.payload.replacementRaisedBy;
          state.activeBreakdownRequest.replacementRaisedByName =
            action.payload.replacementRaisedByName;
          state.activeBreakdownRequest.replacementRaisedAt =
            action.payload.replacementRaisedAt;
        }
      }
    });
    builder.addCase(requestTrikeReplacement.rejected, (state, { payload }) => {
      state.loading = false;
      state.error = payload;
    });

    // get battery sos request details
    builder.addCase(getBatterySosByTrip.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getBatterySosByTrip.fulfilled, (state, action) => {
      state.loading = false;
      state.activeBatterySosRequest = action.payload;
    });
    builder.addCase(getBatterySosByTrip.rejected, (state, { payload }) => {
      state.loading = false;
      state.error = payload;
    });

    // assign battery sos agent
    builder.addCase(assignBatterySosAgent.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(assignBatterySosAgent.fulfilled, (state, action) => {
      state.loading = false;
      state.activeBatterySosRequest = action.payload;
    });
    builder.addCase(assignBatterySosAgent.rejected, (state, { payload }) => {
      state.loading = false;
      state.error = payload;
    });

    // reject battery sos request
    builder.addCase(rejectBatterySos.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(rejectBatterySos.fulfilled, (state, action) => {
      state.loading = false;
      if (state.activeBatterySosRequest) {
        state.activeBatterySosRequest.status = 3; // REJECTED
        if (action.payload) {
          state.activeBatterySosRequest.rejectionReason =
            action.payload.rejectionReason;
          state.activeBatterySosRequest.rejectedBy =
            action.payload.rejectedBy;
          state.activeBatterySosRequest.rejectedByName =
            action.payload.rejectedByName;
          state.activeBatterySosRequest.rejectedAt =
            action.payload.rejectedAt;
        }
      }
    });
    builder.addCase(rejectBatterySos.rejected, (state, { payload }) => {
      state.loading = false;
      state.error = payload;
    });

    // get hub wise batteries
    builder.addCase(getHubWiseBatteries.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getHubWiseBatteries.fulfilled, (state, action) => {
      state.loading = false;
      state.hubWiseBatteries = action.payload.batteries;
    });
    builder.addCase(getHubWiseBatteries.rejected, (state, { payload }) => {
      state.loading = false;
      state.error = payload;
    });
  },
});

export const {
  updateTrips,
  updateMultipleTrips,
  resetTrips,
  updateItemById,
  updateActivityForStop,
  deleteActivityForStop,
  deleteStop,
  updateStopDataForOverallSummary,
} = tripsSlice.actions;

export default tripsSlice.reducer;
